import React from "react";

function ProjectHeader() {
  return (
    <div className="px-10 mt-6">
      <h1 className="text-2xl font-bold">Project Board</h1>
    </div>
  );
}

export default ProjectHeader;
